var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8533eb",
    fillRule: "evenodd",
    d: "M2.778 4a.413.413 0 0 0 .298-.126l2.136-2.213a.423.423 0 0 0 .121-.305c0-.12-.04-.222-.121-.306L4.966.792a.412.412 0 0 0-.594 0l-1.594 1.65L1.187.792a.413.413 0 0 0-.594 0l-.246.258a.41.41 0 0 0-.125.306.41.41 0 0 0 .125.305l2.135 2.213c.081.084.18.126.296.126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPurple);
export default __webpack_public_path__ + "static/media/drop_purple.5004591491d3533f4f9d7e1d1c9f9b90.svg";
export { ForwardRef as ReactComponent };